import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  paper: {
    border: '1px solid #ddd',
    boxShadow: theme.shadows[3],
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    maxWidth: 300,
  },
  typography: {
    color: theme.palette.text.primary,
  },
  button: {
    margin: theme.spacing(2),
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    border: 'none',
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));


export default function CPopper({ anchorEl, open, content }) {
  const classes = useStyles();
  const id = open ? 'transitions-popper' : undefined;

  return (
    <Popper id={id} open={open} anchorEl={anchorEl} transition placement="top">
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Paper className={classes.paper}>
            <Typography className={classes.typography}>{content}</Typography>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};